import { Box, Flex, Heading } from '@chakra-ui/react';
import { ArrowRightIcon } from '@udacity/chakra-uds-icons';

import { ButtonLink } from '~/components/button-link';
import { ContentContainer } from '~/components/container';
import { Markdown } from '~/components/markdown';
import { trackEvent } from '~/features/analytics/track-event';

export function ProgramOfferedSection({
  title,
  programs,
  forcedProgramsOfferedContent,
}: {
  title: string;
  programs?: Array<{
    key: string;
    slug: string;
    title: string;
    summary: string | null;
  }>;
  forcedProgramsOfferedContent?: Array<{
    title: string;
    body: string;
  }>;
}) {
  if (!programs?.length && !forcedProgramsOfferedContent?.length) return null;

  const items = programs?.length ? programs : forcedProgramsOfferedContent;

  return (
    <Box
      as='section'
      backgroundColor='gray.50'
      padding={{
        base: '40px 0px',
        md: '80px 0px',
      }}
    >
      <ContentContainer>
        <Heading
          as='h2'
          size='marketing-5xl'
          textAlign='center'
          marginBottom={{
            base: '24px',
            md: '48px',
          }}
        >
          {title}
        </Heading>
        <Flex
          gap='32px'
          justifyContent='center'
          flexDir={{
            base: 'column',
            md: 'row',
          }}
        >
          {items?.map((item, idx) => {
            const summary = 'summary' in item ? item.summary : item.body;
            const slug = 'slug' in item ? item.slug : null;
            return (
              <Flex
                key={'key' in item ? item.key : item.title}
                as='article'
                backgroundColor='white'
                borderRadius='base'
                boxShadow='xl'
                flex='0 1 352px'
                flexDir='column'
                gap='16px'
                padding='40px 32px 48px'
              >
                <Heading as='p' flexBasis='54px' size='marketing-lg'>
                  {item.title}
                </Heading>
                {!!summary && <Markdown markdownText={summary} />}
                {!!slug && (
                  <ButtonLink
                    buttonProps={{
                      variant: 'link',
                      width: 'fit-content',
                      fontWeight: '700',
                      onClick: () => {
                        trackEvent({
                          name: 'Scholarship Page CTA Clicked',
                          type: 'click',
                          label: 'view_details_clicked',
                          value: item.title,
                        });
                      },
                    }}
                    linkProps={{
                      href: `/course/${slug}`,
                    }}
                  >
                    View Details <ArrowRightIcon height='24px' width='24px' />
                  </ButtonLink>
                )}
              </Flex>
            );
          })}
        </Flex>
      </ContentContainer>
    </Box>
  );
}
